import React from 'react';
import VoxelDivider from '../VoxelDivider';
import { useMenuContext } from './VoxelMenuLogic';

export interface VoxelMenuDividerProps {}

export const VoxelMenuDivider: React.FC<VoxelMenuDividerProps> = ({}) => {
  const { size } = useMenuContext();
  return (
    <div
      className={`
        ${size === 'sm' && 'px-1 py-1.5'}
        ${size === 'md' && 'px-4 py-2.5'}
      `}
    >
      <VoxelDivider color="light" />
    </div>
  );
};

export default VoxelMenuDivider;
